import { PersonalizationScope } from '@decisions/server/DecisionsFramework/Design/Page/Personalization/PersonalizationScope';
import { PersonalizationScopeDef } from '@decisions/server/DecisionsFramework/Design/Page/Personalization/PersonalizationScopeDef';
import { PersonalizationUserScope } from '@decisions/server/DecisionsFramework/Design/Page/Personalization/PersonalizationUserScope';
import { PersonalizationArea } from '@decisions/server/DecisionsFramework/Design/Page/Personalization/PersonalizationArea';
import { IPersonalizationScopeSelectorProps } from '../PersonalizationScopeSelector';

// TODO move this interface somewhere sensible
export interface IPersonalizationValue {
  PersonalizationScope: PersonalizationScopeDef;
  Area: PersonalizationArea;
  Stored: boolean;
}

interface IUseScopeHandlersProps<T extends IPersonalizationValue> {
  value: T;
  path: string[];
  setValue: (value: T) => void;
  onChange: (value: T, path: string[]) => void;
}

export function useScopeHandlers<T extends IPersonalizationValue>({
  value,
  setValue,
  path,
  onChange,
}: IUseScopeHandlersProps<T>) {
  const onScopeChange = (Scope: PersonalizationScope) => {
    const newValue = { ...value, PersonalizationScope: { ...value.PersonalizationScope, Scope } };
    setValue(newValue);
    onChange(newValue, path);
  };

  const onUserScopeChange = (UserScope: PersonalizationUserScope) => {
    const newValue = { ...value, PersonalizationScope: { ...value.PersonalizationScope, UserScope } };
    setValue(newValue);
    onChange(newValue, path);
  };

  const personalization: IPersonalizationScopeSelectorProps = {
    onScopeChange,
    onUserScopeChange,
    scope: value.PersonalizationScope.Scope,
    userScope: value.PersonalizationScope.UserScope,
    active: value.Stored,
  };

  return { onScopeChange, onUserScopeChange, personalization };
}
